// extracted by mini-css-extract-plugin
module.exports = {"children":"DescriptionPoint_children__2U-kv","symbol":"DescriptionPoint_symbol__3L3xx"};